import React, { createContext, useState, useEffect, useCallback } from 'react';

export const ValuationContext = createContext();

export const ValuationProvider = ({ children }) => {
    const [valuationData, setValuationData] = useState(() => {
        try {
            const savedData = sessionStorage.getItem('valuationData');
            return savedData ? JSON.parse(savedData) : {
                entrepreneurInfo: null,
                financialInputs: null,
                financialResults: null,
                assessmentAnswers: null,
                assessmentResults: null
            };
        } catch (error) {
            console.error("Session storage okunurken hata:", error);
            return {
                entrepreneurInfo: null,
                financialInputs: null,
                financialResults: null,
                assessmentAnswers: null,
                assessmentResults: null
            };
        }
    });

    useEffect(() => {
        try {
            sessionStorage.setItem('valuationData', JSON.stringify(valuationData));
        } catch (error) {
            console.error("Session storage yazılırken hata:", error);
        }
    }, [valuationData]);

    const updateEntrepreneurInfo = useCallback((data) => {
        setValuationData(prev => ({ ...prev, entrepreneurInfo: data }));
    }, []);

    const updateFinancials = useCallback((inputs, results) => {
        setValuationData(prev => ({ 
            ...prev, 
            financialInputs: inputs,
            financialResults: results 
        }));
    }, []);

    const updateAssessment = useCallback((answers, results) => {
        setValuationData(prev => ({ 
            ...prev, 
            assessmentAnswers: answers, 
            assessmentResults: results 
        }));
    }, []);

    // Draft'ı temizle fonksiyonu
    const clearDraft = useCallback(async () => {
        try {
            const token = localStorage.getItem('userToken');
            await fetch('/api/drafts/clear', {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            
            // Context'i ve sessionStorage'ı da temizle
            const clearedData = {
                entrepreneurInfo: null,
                financialInputs: null,
                financialResults: null,
                assessmentAnswers: null,
                assessmentResults: null
            };
            
            setValuationData(clearedData);
            sessionStorage.setItem('valuationData', JSON.stringify(clearedData));
            
        } catch (error) {
            console.error('Draft temizleme hatası:', error);
        }
    }, []);

    const [currency, setCurrency] = useState("₺");
    const [valuationCurrency, setValuationCurrency] = useState("€");

    return (
        <ValuationContext.Provider 
            value={{ 
                valuationData, 
                updateEntrepreneurInfo, 
                updateFinancials, 
                updateAssessment,
                clearDraft, // Bu satırı ekle
                currency, setCurrency,
                valuationCurrency, setValuationCurrency
            }}
        >
            {children}
        </ValuationContext.Provider>
    );
};